import { render } from "./CalendarNext.vue?vue&type=template&id=3085b4ab&scoped=true"
import script from "./CalendarNext.vue?vue&type=script&lang=js"
export * from "./CalendarNext.vue?vue&type=script&lang=js"

import "./CalendarNext.vue?vue&type=style&index=0&id=3085b4ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3085b4ab"]])

export default __exports__